export default (payload) => ({
  type: 'STATUS_UPDATE',
  payload,
});
